const translation = {
    PageSize: 'Sidstorlek',
    PageOrientation: 'Sidorientering',
    Format: 'Format',
    DPI: 'DPI',
    Title: 'Exportera karta',
    Close: 'Stäng',
    Save: 'Spara',
    FileName: 'Filnamn',
    Landscape: 'Liggande',
    Portrait: 'Stående',
    PreviewHint: 'Justera området som ska exporteras på kartan eller med knapparna och piltangenterna.',
    ExportFailed: 'Det gick inte att exportera kartan. Försök igen.',
    PreviewFailed: 'Det gick inte att skapa förhandsvisningen.',
    AdjustArea: 'Justera området på kartan',
    AdjustAreaHint: 'Flytta, zooma, rotera eller luta kartan för att rama in området som ska exporteras',
    ZoomIn: 'Zooma in',
    ZoomOut: 'Zooma ut',
    ResetZoom: 'Återställ zoom till 100 %',
    Done: 'Klar',
    Cancel: 'Avbryt',
    Scalebar: 'Skalstock',
    NorthIcon: 'Norrpil',
    ChooseNorthIcon: 'Välj norrpil',
    ChooseSvgFile: 'Välj en SVG-fil',
    IconSymbol: 'Symbol',
    IconColor: 'Färg',
    IconSize: 'Storlek',
    InvalidSvg: 'Filen är inte en giltig SVG.',
    ExportAsVector: 'Exportera som vektor',
    ExportLabelsAsVector: 'Exportera etiketter som vektor',
    Custom: 'Anpassad',
    Width: 'Bredd',
    Height: 'Höjd',
    LanguageName: 'Svenska',
    LanguageCode: 'sv'
};
export default translation;
